import gql from 'graphql-tag';

export const LOG_APPOINTMENT_PARTICIPANT_EVENTS = gql`
  mutation (
    $appointmentId: String!
    $eventType: AppointmentParticipantsEventsType!
    $startAt: Float!
    $endAt: Float
    $data: String
  ) {
    logAppointmentParticipantsEvents (
      input: {
        appointmentId: $appointmentId
        eventType: $eventType
        startAt: $startAt
        endAt: $endAt
        data: $data
      }
    ) {
      appointmentId
    }
  }
`;
